/*
 CardPlatnosc

 Karta z regulaminami platnosci internetowych
  
 historia: 
  PM 2021-10-12 - start
*/

import * as React from 'react';

import { withStyles, WithStyles } from '@material-ui/core/styles';
import { Card, CardContent, Theme, Typography } from '@material-ui/core';

import ResponsiveImgMaterialUi from 'responsive-img-material-ui';
import { Aplikacja } from '../App';
import Przelewy24Standard from './plantosciPrzelewy24/Przelewy24Standard';
import TPayVirtual from './platnosciTPay/TPayVirtual';
import TPayStandard from './platnosciTPay/TPayStandard';

import HotelTest from './regulaminy/HotelTest';

import HaydukPobyt from './regulaminy/HaydukPobyt';
import HaydukPobytEn from './regulaminy/HaydukPobytEn';
import HaydukWynajem from './regulaminy/HaydukWynajem';
import HaydukPDO from './regulaminy/HaydukPDO';

import ApartPobyt from './regulaminy/ApartPobyt';
import ApartWynajem from './regulaminy/ApartWynajem';
import ApartPDO from './regulaminy/ApartPDO';

import ZakopanePobyt from './regulaminy/ZakopanePobyt';
import ZakopaneWynajem from './regulaminy/ZakopaneWynajem';
import ZakopanePDO from './regulaminy/ZakopanePDO';

import WilczastrefaPobyt from './regulaminy/WilczastrefaPobyt';
import WilczastrefaPDO from './regulaminy/WilczastrefaPDO';
import KulinarnePDO from './regulaminy/KulinarnePDO';

import FlatWhitePDO from './regulaminy/FlatWhitePDO';
import FlatWhiteWynajem from './regulaminy/FlatWhiteWynajem';

import LublinSasPobyt from './regulaminy/LublinSasPobyt';
import LublinSasWynajem from './regulaminy/LublinSasWynajem';
import LublinSasPDO from './regulaminy/LublinSasPDO';

import LeskoSkiRegulamin from './regulaminy/LeskoSkiRegulamin';
import LeskoSkiDoladowanie from './regulaminy/LeskoSkiDoladowanie';
import LeskoSkiPDO from './regulaminy/LeskoSkiPDO';
import GreenBBPobyt from './regulaminy/GreenBBPobyt';
import GreenBBWynajem from './regulaminy/GreenBBWynajem';
import GreenBBPDO from './regulaminy/GreenBBPDO';

interface CardPlatnoscProps {
    regulaminy: string,
    aplikacja: Aplikacja,
    lang: string
}

class CardPlatnosc extends React.Component<CardPlatnoscProps & WithStyles<typeof styles>, any> {

    selectComponent = () => {
        switch (this.props.regulaminy) {
            case 'Przelewy24': return this.selectComponentPrzelewy24()
            case 'TPay': return this.selectComponentTPay()
            case 'Regulamin': return this.selectComponentRegulamin()
        }
    }

    //PM 2021-12-10
    //wyrzucenie case 'hotel-TEST'
    selectComponentPrzelewy24 = () => {
        switch (this.props.aplikacja.value) {
            case 'Standard': return <Przelewy24Standard />
            default: return <Przelewy24Standard />
        }
    }

    //PM 2021-10-14
    //default
    selectComponentTPay = () => {
        switch (this.props.aplikacja.value) {
            case 'Standard': return <TPayStandard />
            case 'Virtual': return <TPayVirtual />
            default: return <TPayStandard />
        }
    }

    //PM 2021-12-10
    selectComponentRegulamin = () => {
        switch (this.props.aplikacja.value) {
            case 'hotel-TEST': return <HotelTest />
            case 'zary-HAYDUK-pobyt': 
            if(this.props.lang === "en") return <HaydukPobytEn /> 
            else return <HaydukPobyt />
            case 'zary-HAYDUK-wynajem': return <HaydukWynajem />
            case 'zary-HAYDUK-PDO': return <HaydukPDO />
            case 'zielona-gora-APART-pobyt': return <ApartPobyt />
            case 'zielona-gora-APART-wynajem': return <ApartWynajem />
            case 'zielona-gora-APART-PDO': return <ApartPDO />
            case 'zakopane-DOMKI-WIDOK-pobyt': return <ZakopanePobyt />
            case 'zakopane-DOMKI-WIDOK-wynajem': return <ZakopaneWynajem />
            case 'zakopane-DOMKI-WIDOK-PDO': return <ZakopanePDO />
            case 'wilcza-strefa-pobyt': return <WilczastrefaPobyt />
            case 'wilcza-strefa-PDO': return <WilczastrefaPDO />
            case 'rzeszow-KULINARNE-PDO': return <KulinarnePDO />
            case 'zielona-gora-FLAT-PDO': return <FlatWhitePDO />
            case 'zielona-gora-FLAT-wynajem': return <FlatWhiteWynajem />
            case 'lublin-SAS-pobyt': return <LublinSasPobyt />
            case 'lublin-SAS-wynajem': return <LublinSasWynajem />
            case 'lublin-SAS-PDO': return <LublinSasPDO />
            case 'lesko-SKI-karnet-doladowanie': return <LeskoSkiDoladowanie />
            case 'lesko-SKI-karnet-regulamin': return <LeskoSkiRegulamin />
            case 'lesko-SKI-PDO': return <LeskoSkiPDO />
            case 'zielona-gora-GREEN-BB-pobyt': return <GreenBBPobyt />
            case 'zielona-gora-GREEN-BB-wynajem': return <GreenBBWynajem />
            case 'zielona-gora-GREEN-BB-PDO': return <GreenBBPDO />
            default: return <div></div>
        }
    }

    selectComponentRegulaminLogo = () => {
        switch (this.props.aplikacja.value) {
            case 'zary-HAYDUK-pobyt'  : return require('./logo_hayduk.png').default
            case 'zary-HAYDUK-wynajem': return require('./logo_hayduk.png').default
            case 'zary-HAYDUK-PDO': return require('./logo_hayduk.png').default
            case 'zielona-gora-APART-pobyt' : return require('./logo_apart.png').default
            case 'zielona-gora-APART-wynajem': return require('./logo_apart.png').default
            case 'zielona-gora-APART-PDO': return require('./logo_apart.png').default
            case 'zakopane-DOMKI-WIDOK-pobyt'  : return require('./logo-zakopane.png').default
            case 'zakopane-DOMKI-WIDOK-wynajem': return require('./logo-zakopane.png').default
            case 'zakopane-DOMKI-WIDOK-PDO': return require('./logo-zakopane.png').default
            case 'wilcza-strefa-pobyt': return require('./logo_wilczastrefa.png').default
            case 'wilcza-strefa-PDO': return require('./logo_wilczastrefa.png').default
            case 'rzeszow-KULINARNE-PDO': return require('./logo_kulinarne.png').default
            case 'zielona-gora-FLAT-PDO': return require('./logo_flatwhite.png').default
            case 'zielona-gora-FLAT-wynajem': return require('./logo_flatwhite.png').default
            case 'lublin-SAS-pobyt'  : return require('./logo_lublinsas.png').default
            case 'lublin-SAS-wynajem': return require('./logo_lublinsas.png').default
            case 'lublin-SAS-PDO': return require('./logo_lublinsas.png').default
            case 'lesko-SKI-karnet-doladowanie'  : return require('./logo_leskoski.png').default
            case 'lesko-SKI-karnet-regulamin': return require('./logo_leskoski.png').default
            case 'lesko-SKI-PDO': return require('./logo_leskoski.png').default 
            case 'zielona-gora-GREEN-BB-pobyt'  : return require('./logo-greenbb.png').default
            case 'zielona-gora-GREEN-BB-wynajem': return require('./logo-greenbb.png').default
            case 'zielona-gora-GREEN-BB-PDO': return require('./logo-greenbb.png').default
            default: return require('./logo_virtual.png').default
        }
    }

    selectTitle = () => {
        switch (this.props.aplikacja.value) {
            case 'zary-HAYDUK-pobyt'  : return this.props.aplikacja.text
            case 'zary-HAYDUK-wynajem': return this.props.aplikacja.text
            case 'zary-HAYDUK-PDO': return this.props.aplikacja.text
            case 'zielona-gora-APART-pobyt'  : return this.props.aplikacja.text
            case 'zielona-gora-APART-wynajem': return this.props.aplikacja.text
            case 'zielona-gora-APART-PDO': return this.props.aplikacja.text
            case 'zakopane-DOMKI-WIDOK-pobyt'  : return "DomkiWidokowe" //this.props.aplikacja.text
            case 'zakopane-DOMKI-WIDOK-wynajem': return "DomkiWidokowe" //this.props.aplikacja.text
            case 'zakopane-DOMKI-WIDOK-PDO': return "DomkiWidokowe" //this.props.aplikacja.text
            case 'wilcza-strefa-pobyt'  : return "WilczaStrefa" //this.props.aplikacja.text
            case 'wilcza-strefa-PDO': return "WilczaStrefa" //this.props.aplikacja.text
            case 'rzeszow-KULINARNE-PDO': return this.props.aplikacja.text
            case 'zielona-gora-FLAT-PDO': return this.props.aplikacja.text
            case 'zielona-gora-FLAT-wynajem': return this.props.aplikacja.text
            case 'lublin-SAS-pobyt'  : return "SAS rooms&restaurant" //this.props.aplikacja.text
            case 'lublin-SAS-wynajem': return "SAS rooms&restaurant" //this.props.aplikacja.text
            case 'lublin-SAS-PDO': return "SAS rooms&restaurant" //this.props.aplikacja.text
            case 'lesko-SKI-karnet-doladowanie'  : return "Lesko Summer & Ski" //this.props.aplikacja.text
            case 'lesko-SKI-karnet-regulamin': return "Lesko Summer & Ski" //this.props.aplikacja.text
            case 'lesko-SKI-PDO': return "Lesko Summer & Ski" //this.props.aplikacja.text
            case 'zielona-gora-GREEN-BB-pobyt'  : return this.props.aplikacja.text
            case 'zielona-gora-GREEN-BB-wynajem': return this.props.aplikacja.text
            case 'zielona-gora-GREEN-BB-PDO': return this.props.aplikacja.text
            default: return (this.props.regulaminy + ((this.props.aplikacja.value !== 'Standard') ? ' - ' + this.props.aplikacja.text : ''))
        }
    }

    //PM 2021-11-05
    //<Typography gutterBottom component="h1" variant="h6">
    //${this.props.aplikacja.value !== 'Standard' ? ' - ' + this.props.aplikacja.text : ''}
    render() {
        const { classes } = this.props;

        let smallLogo = this.props.aplikacja.value.includes("zielona-gora-FLAT") || this.props.aplikacja.value.includes("zielona-gora-GREEN-BB") 

        return (
            <Card elevation={0} className={classes.card}>

                <div style={{display: "inline-flex", width: "100%"}}>
                    <div style={{width: "inherit", display: "flex", alignItems: "center"}} className={classes.inlineBlock}>
                        <Typography gutterBottom component="h1" variant="h6">
                            <b>{this.selectTitle()}</b>
                        </Typography>
                    </div>

                    <span style={{ float: "right", paddingRight: "5px" }} className={classes.inlineBlock}>
                        <ResponsiveImgMaterialUi 
                            //style={{ height: "100%", width: "100%" }}
                            style={{ maxHeight: smallLogo ? "50px" : "100px" }}
                            xs={this.selectComponentRegulaminLogo()}
                            md={this.selectComponentRegulaminLogo()}
                            lg={this.selectComponentRegulaminLogo()}
                        />
                    </span>

                </div>
                <hr style={{ border: "0", borderBottom: "1px solid rgb(224, 224, 224)" }} />
                <CardContent>
                    {this.selectComponent()}
                </CardContent>
            </Card>
        );
    }
}

const styles = (theme: Theme) => ({
    inlineBlock: {
        display: 'inline-block'
    },
    card: {
        paddingTop: theme.spacing(6)
    },
});

export default withStyles(styles)(CardPlatnosc);
